import { render } from "./FirstAnniversaryForTalentScreen.vue?vue&type=template&id=9f8ecbd2&scoped=true&ts=true&lang=pug"
import script from "./FirstAnniversaryForTalentScreen.vue?vue&type=script&lang=ts"
export * from "./FirstAnniversaryForTalentScreen.vue?vue&type=script&lang=ts"

import "./FirstAnniversaryForTalentScreen.vue?vue&type=style&index=0&id=9f8ecbd2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f8ecbd2"]])

export default __exports__